@if (visualisationItem) {
  <article>
    <header> {{visualisationItem.title}} </header>
    <main>
      <app-visualise-data [visualisationItem]="visualisationItem"></app-visualise-data>
    </main>
    <footer></footer>
  </article>
} @else {
  <i class="fa fa-fw fa-spin fa-refresh"></i>
}

